//@ts-nocheck
//@ts-ignore
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react-lite";
import React, { useRef, useState } from "react";
import {
  OverlayWrapper,
  useOverlayDisclosure,
} from "../../../components/OverlayRouter";
import { TeacherGenderField } from "../../../components/form-elements/GenderField";
import Icon from "../../../components/ui-elements/Icon";
import { possessiveNoun } from "../../../utils/functions";
import { formatClass } from "../../request-flow/ChildFormPage";
import {
  SubjectSelectorProvider,
  useSubjectSelectorContext,
} from "../components/SubjectSelector/hook";
import ChildForm, { initialValue as newChild, placeholders } from "./ChildForm";
export { newChild };

type ChildSummaryProps = {
  viewModel: any;
  onEdit: any;
  loading: boolean;
  customerType: any;
  onNextClick: (gender?: string) => Promise<any>;
  nextButtonText?: string;
  displayGender?: boolean;
  [key: string]: any;
  canSelectChild?: boolean;
};

const ChildSummary: React.FC<ChildSummaryProps> = observer(
  ({
    viewModel,
    onEdit,
    loading,
    customerType,
    onNextClick,
    nextButtonText = "Next: Tutors",
    displayGender,
    canSelectChild,
    ...rest
  }) => {
    const isParent = customerType === "parent";
    const [gender, setGender] = useState("any");

    const handleChildClick = (index, child) => {
      // if (viewModel.childDetails[index].disabled) return;

      console.log(child);
      if (viewModel.childDetails.find((c) => c.id === child.id)) {
        return viewModel.remove(
          viewModel.childDetails.findIndex((c) => c.id === child.id)
        );
      }
      return viewModel.addNewChild(child);
    };

    // const _childDetails = canSelectChild ? viewModel.selectedChildDetails : viewModel.childDetails;
    return (
      <Stack {...rest}>
        {viewModel.isPopulated ? (
          <Stack spacing={3}>
            {canSelectChild && (
              <Box mt="10" mb="10">
                <Text fontWeight="semibold" fontSize={"xl"}>
                  Select Child
                </Text>

                <Box
                  display={"grid"}
                  gridTemplateColumns={{
                    base: "1fr",
                    sm: "1fr 1fr",
                    md: `${
                      viewModel.defaultChildDetails.length < 3
                        ? viewModel.defaultChildDetails.length
                        : "1fr 1fr 1fr"
                    }`,
                  }}
                  columnGap={"10rem"}
                  rowGap={"1.5rem"}
                  mt="5"
                >
                  {viewModel.defaultChildDetails.map((child, index) => (
                    <Button
                      key={index}
                      border="2px solid"
                      // borderColor={"blue.500"}
                      // borderRadius="md"
                      colorScheme="blue"
                      variant={
                        viewModel.childDetails.find((c) => c.id === child.id)
                          ? "solid"
                          : "outline"
                      }
                      py="2"
                      px="1"
                      cursor="pointer"
                      onClick={() => handleChildClick(index, child)}
                      fontWeight="normal"
                      disabled={child.disabled}
                    >
                      {child.firstName}
                    </Button>
                  ))}
                </Box>
              </Box>
            )}
            {viewModel.childDetails.length >= 1 && (
              <>
                <Flex align="center" justifyContent="space-between">
                  <Text fontWeight="semibold" fontSize="sm" color="gray.500">
                    STUDENTS {canSelectChild ? "TO EDIT" : ""}
                  </Text>

                  <Button
                    display={["block", "block", "none"]}
                    leftIcon={<AddIcon />}
                    onClick={() => onEdit(null)}
                    variant="link"
                    colorScheme="blue"
                  >
                    Another child
                  </Button>
                </Flex>
                <Box borderWidth="2xs" rounded="fbRadius">
                  {viewModel.childDetails.map((child, index) => (
                    <Box key={index}>
                      <EachChild
                        childData={child}
                        onEdit={() => onEdit(index)}
                      />
                      {index + 1 !== viewModel.childDetails.length && <hr />}
                    </Box>
                  ))}
                </Box>
                {/* Display the gender for the tutor to be hired */}
                {displayGender && (
                  <FormControl>
                    <FormLabel>Select the gender of the tutor</FormLabel>
                    <TeacherGenderField
                      defaultValue={gender}
                      teacherGenderOptions={["any", "male", "female"].map(
                        (o) => ({
                          label: o,
                          value: o,
                        })
                      )}
                      onChange={(e) => {
                        setGender(e.target.value);
                      }}
                    />
                  </FormControl>
                )}
              </>
            )}

            <Flex pt={5} justify="space-between" align="center">
              <Button
                size="lg"
                leftIcon={<AddIcon />}
                variant="outline"
                colorScheme="blue"
                display={["none", "none", "block"]}
                onClick={() => onEdit(null)}
              >
                {isParent ? "Another child" : "Add student"}
              </Button>
              <Box display={["none", "none", "block"]} flex={1} />
              {viewModel.childDetails.length >= 1 && (
                <Button
                  size="lg"
                  width={["100%", "100%", "50%"]}
                  onClick={() => onNextClick({ gender })}
                  isLoading={loading}
                  loadingText="Submitting"
                  colorScheme="blue"
                  mt={[2, 0]}
                >
                  {nextButtonText}
                </Button>
              )}
            </Flex>
          </Stack>
        ) : (
          <Button
            mt={5}
            colorScheme="blue"
            onClick={() => onEdit(null)}
            leftIcon={<AddIcon />}
            width={["100%", "100%", "50%"]}
            alignSelf="flex-start"
            size="lg"
          >
            {isParent ? "Add child details" : "Add student details"}
          </Button>
        )}
      </Stack>
    );
  }
);

type ChildFormType = {
  onSubmit: any;
  spacing?: any;
  loading: boolean;
  onNextClick: any;
  dataType: any;
  customerType: any;
  viewModel: any;
  updateFormIndex: any;
  path?: string;
  nextButtonText?: string;
  [key: string]: any;
  canSelectChild?: boolean;
};

const ChildFormArray: React.FC<ChildFormType> = observer(
  ({
    onSubmit,
    spacing = "20px",
    loading,
    onNextClick = () => {},
    dataType,
    customerType,
    viewModel,
    updateFormIndex,
    path,
    nextButtonText,
    displayGender,
    canSelectChild,
    ...rest
  }) => {
    const editFormInArray = useEditSingleForm("/detail");

    return (
      <Box className="Child Form" {...rest}>
        <ChildSummary
          viewModel={viewModel}
          nextButtonText={nextButtonText}
          customerType={customerType}
          loading={loading}
          onEdit={(...rst) => {
            editFormInArray.onEdit(...rst);
            if (updateFormIndex) {
              updateFormIndex();
            }
          }}
          displayGender={displayGender}
          onNextClick={(...rst) => {
            onNextClick(...rst);
            if (updateFormIndex) {
              updateFormIndex();
            }
          }}
          canSelectChild={canSelectChild}
        />
        <OverlayWrapper
          key={editFormInArray.formIndex}
          exact={false}
          path={"/detail"}
        >
          {editFormInArray.isOpen ? (
            <SubjectSelectorProvider
              path="/detail/subject-edit"
              paths="/detail/:sub_page"
              dataType={dataType}
              placeholders={placeholders}
            >
              <EachChildDrawer
                dataType={dataType}
                customerType={customerType}
                onSaveEdit={(data) => {
                  viewModel.replaceData(editFormInArray.formIndex, {
                    ...data,
                    name: data.firstName || "",
                  });
                }}
                onRemove={() => viewModel.remove(editFormInArray.formIndex)}
                onAddChild={(data) =>
                  viewModel.addNewChild({ ...data, name: data.firstName || "" })
                }
                values={viewModel.childDetails}
                {...editFormInArray}
              />
            </SubjectSelectorProvider>
          ) : (
            <></>
          )}
        </OverlayWrapper>
      </Box>
    );
  }
);

export default ChildFormArray;

const EachChild = ({ childData, onEdit = () => {}, ...rest }) => {
  const {
    firstName,
    classDetail: { class: klass, purpose, subjects },
  } = childData;
  const purposeText = purpose.split("_").join(" ");
  const classText = formatClass(klass);

  return firstName ? (
    <Flex
      justify="space-between"
      align="center"
      py={[3, 4]}
      px={[4, 5]}
      {...rest}
    >
      <Box fontSize="sm" flex={1}>
        <Text fontWeight="medium">
          {firstName.trim()}, {classText}
        </Text>

        <Text opacity="0.8">{purposeText}</Text>
      </Box>

      <Button
        size="sm"
        leftIcon={<EditIcon />}
        variant="ghost"
        ml={[3, 8]}
        colorScheme="blue"
        onClick={onEdit}
      >
        Edit
      </Button>
    </Flex>
  ) : (
    <Box />
  );
};

const EachChildDrawer = observer(
  ({
    values = [],
    formIndex,
    onSaveEdit = () => {},
    onAddChild = () => {},
    customerType,
    onRemove = () => {},
    isOpen,
    onClose = () => {},
    dataType,
    path,
  }: any) => {
    let subjectSelectManager: any = useSubjectSelectorContext();
    let childData = formIndex >= 0 ? values[formIndex] : undefined;
    const formikFormRef = useRef();
    const [value, setValue] = useState(childData);
    const [removeChild, setRemoveChild] = useState(false);
    // const detectMobile = useMobileDetect();
    React.useEffect(() => {
      console.log("childdata", childData);
      setValue(childData);
    }, [childData]);

    function OverrideOnSaveEdit(value) {
      if (value) {
        let { subjects = [] } = value.classDetail.subjects;
        if (subjects.length > 0) {
          subjectSelectManager.onChange(value.classDetail);
        }
      }

      if (formIndex >= 0) onSaveEdit(value);
      if (formIndex === null) onAddChild(value);
    }

    const handleSave = () => {
      const form: any = formikFormRef.current;
      form.submitForm();
      if (isEmpty(form.errors)) {
        OverrideOnSaveEdit(form.values);
        subjectSelectManager.onChange({ subjects: [] });

        onClose();
      }
    };

    const handleRemoveClick = () => {
      onRemove();
      setRemoveChild(false);
      onClose();
    };

    const handleCloseClick = () => {
      onClose();
    };
    // console.log("dataType", dataType);
    return (
      <Modal
        isOpen={isOpen}
        onClose={handleCloseClick}
        size="2xl"
        isFullHeight
        scrollBehavior="inside"
        closeOnOverlayClick={false}
        className="child-form-drawer"
      >
        <ModalOverlay />
        <ModalContent
          shadow="fbShadow"
          mx="3"
          overflow="hidden"
          rounded="fbRadius"
          bg="neutral.200"
        >
          <ModalCloseButton />
          <ModalHeader p={0}>
            <Box
              px={[5, 6]}
              fontSize="xl"
              fontWeight="black"
              py={4}
              bg="white"
              borderBottomWidth="2xs"
            >
              {childData ? (
                `Edit ${possessiveNoun(childData.firstName)} details`
              ) : (
                <Box>
                  <Stack isInline align="center">
                    <Text>
                      {customerType === "parent"
                        ? "Add child details"
                        : "Add student details"}
                    </Text>
                    <Icon name="lock" size={4} />
                  </Stack>

                  <Text fontSize="md" fontWeight="normal" opacity={0.8}>
                    Information shared is confidential
                  </Text>
                </Box>
              )}
            </Box>
          </ModalHeader>
          <ModalBody py={[6, 10]} bg="white">
            <ChildForm
              path={path}
              dataType={dataType}
              onSubmit={(data) => setValue(data)}
              ref={formikFormRef}
              value={value}
            />
          </ModalBody>
          <ModalFooter
            py={4}
            borderTopWidth="2xs"
            bg="neutral.50"
            display="block"
          >
            <Flex align="center" justify="space-between">
              {formIndex === null ? (
                <Box />
              ) : (
                <Box>
                  {removeChild ? (
                    <Button
                      variant="link"
                      colorScheme="red"
                      leftIcon={<DeleteIcon />}
                      onClick={handleRemoveClick}
                    >
                      Delete?
                    </Button>
                  ) : (
                    <Button
                      leftIcon={<DeleteIcon />}
                      variant="link"
                      colorScheme="red"
                      onClick={() => setRemoveChild(true)}
                    >
                      Remove
                    </Button>
                  )}
                </Box>
              )}

              <HStack spacing={3}>
                <Button
                  fontSize="md"
                  variant="outline"
                  size="lg"
                  onClick={handleCloseClick}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  size="lg"
                  fontSize="md"
                  onClick={handleSave}
                  colorScheme="blue"
                >
                  Save
                </Button>
              </HStack>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
);

function useEditSingleForm(path: string) {
  const [formIndex, setFormIndex] = useState(null);
  const { isOpen, onClose, onOpen } = useOverlayDisclosure(path);

  function onEdit(index: any) {
    setFormIndex(index);
    onOpen();
  }

  return { onOpen, isOpen, onClose, onEdit, formIndex, path };
}
